(() => {
  'use strict';
  const lang = (document.documentElement.lang || '').toLowerCase();

  // First visit: if the storefront is in Spanish but the browser is English,
  // send the visitor to Shopify's published /en storefront. Never force the
  // reverse direction, and never redirect inside the theme editor.
  if (!window.Shopify?.designMode && lang.startsWith('es')) {
    const preferred = (navigator.languages?.[0] || navigator.language || '').toLowerCase();
    const alreadyChecked = sessionStorage.getItem('wizzy_locale_checked') === '1';
    if (!alreadyChecked && preferred.startsWith('en') && !/^\/en(?:\/|$)/i.test(location.pathname)) {
      sessionStorage.setItem('wizzy_locale_checked','1');
      const path = location.pathname === '/' ? '' : location.pathname;
      location.replace('/en' + path + location.search + location.hash);
      return;
    }
    if (!alreadyChecked) sessionStorage.setItem('wizzy_locale_checked','1');
  }

  if (!lang.startsWith('en')) return;

  const pairs = Array.isArray(window.WIZZY_I18N_EN) ? window.WIZZY_I18N_EN : [];
  const exact = new Map(pairs);
  const skipTags = new Set(['SCRIPT','STYLE','NOSCRIPT','CODE','PRE','TEXTAREA']);
  const months = {enero:'January',febrero:'February',marzo:'March',abril:'April',mayo:'May',junio:'June',julio:'July',agosto:'August',augosto:'August',septiembre:'September',octubre:'October',noviembre:'November',diciembre:'December'};
  const localizedImages = [
    {
      from: 'ChatGPT_Image_20_ene_2026_01_31_21.png',
      to: 'https://cdn.shopify.com/s/files/1/0944/8351/3675/files/ChatGPT_Image_6_sept_2026_01_59_14.png?v=1788652776'
    }
  ];

  function tr(input) {
    if (!input || typeof input !== 'string') return input;
    const lead = input.match(/^\s*/)?.[0] || '';
    const trail = input.match(/\s*$/)?.[0] || '';
    let core = input.slice(lead.length, input.length - trail.length);
    if (!core) return input;
    if (exact.has(core)) core = exact.get(core);
    else {
      core = core.replace(/\b(\d{1,2})\s+de\s+(enero|febrero|marzo|abril|mayo|junio|julio|agosto|augosto|septiembre|octubre|noviembre|diciembre)\s+de\s+(\d{4})\b/gi, (_,d,m,y) => `${months[m.toLowerCase()] || m} ${d}, ${y}`);
      const reps = [
        [/\bAhorra\s+(\d+)%/g,'Save $1%'],[/^Ahorras\s+/i,'You save '],[/\b(\d+)\s+productos\b/g,'$1 products'],[/\b(\d+)\s+pedidos hoy\b/g,'$1 orders today'],
        [/^Ver\s+(.+)$/i,'View $1'],[/^Añadir al carrito\s*·\s*/i,'Add to cart · '],[/^Añadir al carrito$/i,'Add to cart'],[/^Agotado$/i,'Sold out'],[/^Comprar ahora$/i,'Buy now'],[/^Más información$/i,'Learn more'],[/^Volver$/i,'Back'],[/^Cerrar$/i,'Close'],[/^Buscar$/i,'Search'],
        [/\breseñas verificadas\b/gi,'verified reviews'],[/\bPago seguro\b/g,'Secure payment'],[/\bCompra segura\b/g,'Secure purchase'],[/\bSoporte WizzyWand\b/g,'WizzyWand support'],[/\bEnvío gratis\b/g,'Free shipping'],[/\bEnvío asegurado\b/g,'Insured shipping'],[/\b90 días de garantía\b/gi,'90-day guarantee'],[/\b30 días de garantía\b/gi,'30-day guarantee'],[/\bOtros productos que también pueden encantarte\b/g,'Other products you may also love'],[/\bTambién te puede gustar\b/g,'You may also like'],[/\bAntes de comprar\b/g,'Before you buy'],[/\bproductos\b/g,'products']
      ];
      for (const [rx,to] of reps) core = core.replace(rx,to);
      if (exact.has(core)) core = exact.get(core);
    }
    return lead + core + trail;
  }

  function blocked(node) { const p=node.parentElement; return !p || skipTags.has(p.tagName) || p.closest('[data-wizzy-no-translate]'); }
  function textNode(node) { if (!node || node.nodeType!==Node.TEXT_NODE || blocked(node)) return; const next=tr(node.nodeValue); if(next!==node.nodeValue) node.nodeValue=next; }
  function attrs(el) {
    if (!(el instanceof Element) || skipTags.has(el.tagName) || el.closest('[data-wizzy-no-translate]')) return;
    for (const a of ['placeholder','aria-label','title']) { if(!el.hasAttribute(a)) continue; const old=el.getAttribute(a),next=tr(old); if(next!==old) el.setAttribute(a,next); }
    if(el.matches('input[type="submit"],input[type="button"]')&&el.hasAttribute('value')){const old=el.getAttribute('value'),next=tr(old);if(next!==old)el.setAttribute('value',next);}
  }
  function link(el) {
    if (!(el instanceof HTMLAnchorElement)) return;
    const href=el.getAttribute('href');
    if(!href||!href.startsWith('/')||href.startsWith('//')||/^\/en(?:\/|$|\?)/i.test(href))return;
    if(!/^\/(collections|products|pages|search|cart|policies|blogs)(?:\/|$|\?)/i.test(href))return;
    const root=(window.Shopify?.routes?.root||'').replace(/\/$/,'');
    if(!root||root==='/'||!/^\/en(?:\/|$)/i.test(root+'/'))return;
    el.setAttribute('href',root+href);
  }
  function image(el) {
    if (!(el instanceof HTMLImageElement)) return;
    const source = `${el.currentSrc || ''} ${el.getAttribute('src') || ''} ${el.getAttribute('srcset') || ''}`;
    for (const pair of localizedImages) {
      if (!source.includes(pair.from)) continue;
      if (el.getAttribute('src') !== pair.to) el.setAttribute('src', pair.to);
      if (el.hasAttribute('srcset')) el.setAttribute('srcset', pair.to);
      break;
    }
  }
  function tree(root) {
    if(!root)return; if(root.nodeType===Node.TEXT_NODE)return textNode(root);
    if(!(root instanceof Element)&&root!==document.body&&root!==document.documentElement)return;
    if(root instanceof Element){attrs(root);link(root);image(root);}
    const w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:n=>blocked(n)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT}); let n; while((n=w.nextNode()))textNode(n);
    if(root.querySelectorAll){
      root.querySelectorAll('[placeholder],[aria-label],[title],input[type="submit"],input[type="button"],a[href]').forEach(el=>{attrs(el);link(el);});
      root.querySelectorAll('img').forEach(image);
    }
  }
  let queued=false; const pending=new Set();
  function queue(node){if(node)pending.add(node);if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;const items=[...pending];pending.clear();items.forEach(tree);});}
  function boot(){tree(document.body);const observer=new MutationObserver(records=>{for(const r of records){if(r.type==='characterData'||r.type==='attributes')queue(r.target);else r.addedNodes.forEach(queue);}});observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['placeholder','aria-label','title','value','href','src','srcset']});document.addEventListener('shopify:section:load',e=>queue(e.target));}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
